import { useEffect, useState } from "react";
import { siteNav } from "@/mocks/homeContent";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const light = !scrolled;
  const base =
    "left-0 top-0 z-50 w-full transition-colors duration-300 " +
    (scrolled ? "fixed bg-background-50/95 backdrop-blur" : "absolute bg-transparent");
  const linkCls = (onDark: boolean) =>
    "whitespace-nowrap text-sm tracking-wide transition-colors hover:opacity-80 " +
    (onDark ? "text-background-100/90" : "text-foreground-700");

  return (
    <header className={base}>
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:h-[72px] md:px-6">
        <a href="#home" className="flex items-center gap-2">
          <span
            className={
              "flex h-8 w-8 items-center justify-center rounded-sm font-heading text-lg font-black text-background-50 " +
              "bg-primary-600"
            }
          >
            黑
          </span>
          <span
            className={
              "font-heading text-xl font-bold tracking-wide md:text-2xl " +
              (light ? "text-background-50" : "text-foreground-950")
            }
          >
            黑料社
          </span>
        </a>

        <nav className="hidden items-center gap-6 lg:flex">
          {siteNav.map((n, i) => (
            <a
              key={n.key}
              href={`#${i === 0 ? "home" : n.key}`}
              className={linkCls(light)}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <button
            aria-label="搜索"
            className={
              "flex h-10 w-10 items-center justify-center rounded-full " +
              (light ? "text-background-50/90 hover:bg-background-50/10" : "text-foreground-700 hover:bg-background-200")
            }
          >
            <i className="ri-search-line text-lg" />
          </button>
          <a
            href="#archive"
            className={
              "whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors " +
              "hover:bg-primary-500"
            }
          >
            提供线索
          </a>
        </div>

        <button
          aria-label="菜单"
          onClick={() => setOpen((v) => !v)}
          className={
            "flex h-10 w-10 items-center justify-center rounded-full lg:hidden " +
            (light ? "text-background-50" : "text-foreground-800")
          }
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
          <div className="flex flex-col gap-1">
            {siteNav.map((n) => (
              <a
                key={n.key}
                href={`#${n.key}`}
                onClick={() => setOpen(false)}
                className="rounded-md px-2 py-2 text-[15px] text-foreground-800 hover:bg-background-100"
              >
                {n.label}
              </a>
            ))}
            <a
              href="#archive"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-md bg-primary-600 px-3 py-2 text-center text-sm font-medium text-background-50"
            >
              提供线索
            </a>
          </div>
        </div>
      )}
    </header>
  );
}